import { createSelector } from 'reselect';

import { FLAG_KEYS } from 'lib/constants';
import { getLaunchDarklyFlags } from './getLaunchDarklyFlags';

const getShiftHandoverEnabled = createSelector(
  [getLaunchDarklyFlags],
  (flags) => {
    return flags?.[FLAG_KEYS.SHIFT_HANDOVER_ENABLED];
  }
);

export { getShiftHandoverEnabled };
